import React from "react";
import { Dialog, DialogContent, DialogActions, Button, IconButton } from "@mui/material";
import CloseRounded from "@mui/icons-material/CloseRounded";
import WarningAmberRounded from "@mui/icons-material/WarningAmberRounded";

const ConfirmRemove = ({ employee, onClose, onConfirm }) => (
    <Dialog open={Boolean(employee)} onClose={onClose} fullWidth maxWidth="xs" className="wh-dialog wh-dialog--danger">
        {employee && (
            <>
                <div className="wh-dialog-head">
                    <div className="wh-dialog-headings">
                        <h5>Remove {employee.employeeName}?</h5>
                        <p>{employee.employeeCode}</p>
                    </div>
                    <IconButton className="wh-dialog-close" onClick={onClose} aria-label="Close">
                        <CloseRounded />
                    </IconButton>
                </div>

                <DialogContent>
                    <div className="wh-warn">
                        <WarningAmberRounded />
                        <p>
                            They will be moved to the inactive list and will no longer appear here or be able
                            to sign in. Their reports and history are kept.
                        </p>
                    </div>
                </DialogContent>

                <DialogActions>
                    <Button variant="contained" color="inherit" onClick={onClose}>Keep employee</Button>
                    <Button variant="contained" color="error" onClick={onConfirm}>Remove</Button>
                </DialogActions>
            </>
        )}
    </Dialog>
);

export default ConfirmRemove;
